import { render, staticRenderFns } from "./Silder.vue?vue&type=template&id=5bb66942"
import script from "./Silder.vue?vue&type=script&lang=js"
export * from "./Silder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports